
import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Paper,
    TextField,
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel,
    FormLabel,
    Typography,
    InputAdornment,
    MenuItem,
    Chip,
    Button
} from "@mui/material";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import ApiService from "../../functions/apiService";
import { toast } from "react-toastify";
import moment from "moment/moment";
import { CircularProgress } from "@material-ui/core";
import MyTable from "../../components/Schedule/MyTable";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

const ReqComponent = () => <span className="text-danger">*</span>;

const OffDutyTraining = () => {

    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);
    const [odtRows, setOdtRows] = useState([]);
    const [formData, setFormData] = useState({
        className: "",
        location: "",
        date: null,
        days: "",
        paidStatus: "",
        paymentType: null,
        startTime: null,
        endTime: null,
    });
    const formatTime = (dateObj) => {
        if (!dateObj) return null;
        return dateObj.toTimeString().slice(0, 8);
    };

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    console.log("odtRow===>", odtRows)

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            Request_Date: moment(formData.date).format('YYYY-MM-DD'),
            Class_Name: formData.className,
            Training_Start_Time: formatTime(formData.startTime),
            Training_End_Time: formatTime(formData.endTime),
            Is_Paid: formData.paidStatus === "paid",
            Payment_Type: formData.paidStatus === "paid" ? formData.paymentType : null,
            Training_Location: formData.location
        };

        // console.log("Final Payload:===>71", payload);

        sendTrainingRequest(payload);
    };

    const sendTrainingRequest = async (data) => {
        try {
            // console.log("API Request Payload:", data);
            const response = await ApiService.post('/offDutyTraining/store', data)
            // console.log("API Response:===>91", response);

            toast.success(response.message)
            setFormData({
                className: "",
                location: "",
                date: null,
                days: "",
                paidStatus: "",
                paymentType: null,
                startTime: null,
                endTime: null,
            });

            fetchTrainingList();

        } catch (error) {
            toast.error(error.data.message)
            console.error("API Error:", error);
        }
    };

    const fetchTrainingList = async () => {
        try {
            setLoading(true);
            const res = await ApiService.get('/userOffDutyTraining');
            // console.log("resp===>102", res)
            setOdtRows(res?.data?.data ?? []);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTrainingList();
    }, []);

    const odtColumns = [
        {
            field: "RequestDateEmployee",
            headerName: "Date / Employee",
            flex: 1,
            minWidth: 130,
            renderCell: (params) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>{moment(params?.row?.Request_Date).format('MM/DD/YYYY')}</span>
                    <span>{params?.row?.employee?.fullName}</span>
                </div>
            )
        },
        {
            field: "Class_Name",
            headerName: "Class Name",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => <div
             style={{
                padding: "14px 0",
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                lineHeight: "1.4"
            }}
            >{params?.row?.Class_Name}</div>

        },
        {
            field: "TrainingTime",
            headerName: "Start / End Time",
            flex: 1,
            minWidth: 130,
            renderCell: (params) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>{params?.row?.Training_Start_Time}</span>
                    <span>{params?.row?.Training_End_Time}</span>
                </div>
            )
        },
        {
            field: "PaidInfo",
            headerName: "Payment Info",
            flex: 1,
            minWidth: 160,
            renderCell: (params) => {
                const isPaid = params?.row?.Is_Paid;
                const paymentType = params?.row?.Payment_Type;
                const formattedType = paymentType
                    ? paymentType.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
                    : "NA";

                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span>{isPaid ? "Paid" : "Unpaid"}</span>
                        <span>{isPaid ? formattedType : "NA"}</span>
                    </div>
                );
            }
        },

        {
            field: "Training_Location",
            headerName: "Location",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => <div 
            style={{
                padding: "14px 0",
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                lineHeight: "1.4"
            }}
            >{params?.row?.Training_Location}</div>

        },
        {
            field: "Status",
            headerName: "Status",
            flex: 1,
            minWidth: 120,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    sx={{
                        backgroundColor: params.value === 'Pending'
                            ? 'rgba(255, 165, 0, 0.16)'
                            : params.value === 'Approved'
                                ? 'rgba(1, 120, 79, 0.1)'
                                : 'rgba(230, 39, 25, 0.1)',
                        color: params.value === 'Pending'
                            ? '#FF8C00'
                            : params.value === 'Approved'
                                ? 'rgba(1, 120, 79, 1)'
                                : '#ff0000',
                        border: params.value === 'Pending'
                            ? '1px solid rgba(255, 165, 0, 0.28)'
                            : params.value === 'Approved'
                                ? '1px solid rgba(1, 120, 79, 1)'
                                : '1px solid rgba(230, 39, 25, 0.4)'
                    }}
                />
            )
        },
        {
            field: "Action_By",
            headerName: "Action By",
            flex: 1,
            minWidth: 120,
            renderCell: (params) => <div style={{ padding: '14px 0px' }}>{params?.row?.action_by_employee?.fullName}</div>
        },
        //   {
        //     field: "actions",
        //     headerName: "Actions",
        //     flex: 1,
        //     minWidth: 180,
        //     sortable: false,
        //     filterable: false,
        //     renderCell: (params) => {
        //       // Only show actions if status is Pending
        //       if (params.row.Status !== 'Pending') {
        //         return null;
        //       }

        //       return (
        //         <div style={{ display: "flex", gap: 12 }}>
        //           <Button
        //             onClick={() => handleOdtAction(params.row, 'approve')}
        //             sx={{
        //               color: "#555555",
        //               minWidth: "0",
        //               paddingRight: ".02rem",
        //               ":hover": { color: "green", background: "none" },
        //             }}
        //             startIcon={<CheckIcon />}
        //             disabled={saving}
        //           />
        //           <Button
        //             onClick={() => handleOdtAction(params.row, 'reject')}
        //             sx={{
        //               color: "#555555",
        //               minWidth: "0",
        //               paddingRight: ".02rem",
        //               ":hover": { color: "red", background: "none" },
        //             }}
        //             startIcon={<ClearIcon />}
        //             disabled={saving}
        //           />
        //         </div>
        //       );
        //     },
        //   }

    ];

    return (<>
        <Paper className="p-4" style={{ marginTop: "1rem" }}>
            <Typography variant="h6" className="mb-3">
                Off-Duty Training
            </Typography>


            <form onSubmit={handleSubmit}>
                <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>


                    <Grid item xs={6}>
                        <label style={{ fontSize: "14px", marginBottom: "9px" }}>
                            Class Name <ReqComponent />
                        </label>
                        <TextField
                            fullWidth
                            label="Class Name"
                            InputProps={{
                                sx: {
                                    height: '48px',
                                    fontSize: '14px'
                                }
                            }}
                            placeholder="Enter class name"
                            size="small"
                            value={formData.className}
                            onChange={(e) => handleChange("className", e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <label style={{ fontSize: "14px", marginBottom: "9px" }}>
                            Location of Training <ReqComponent />
                        </label>
                        <TextField
                            fullWidth
                            InputProps={{
                                sx: {
                                    height: '48px',
                                    fontSize: '14px'
                                }
                            }}
                            size="small"
                            label="Location of Training"
                            placeholder="Enter location"
                            value={formData.location}
                            onChange={(e) => handleChange("location", e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <label style={{ fontSize: "14px", marginBottom: "9px" }}>
                            Date <ReqComponent />
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                value={formData.date}
                                onChange={(value) => handleChange("date", value)}
                                sx={{
                                    width: "100%",
                                    "& .MuiInputBase-root": {
                                        height: "48px",
                                        fontSize: "14px",
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <label style={{ fontSize: "14px" }}>
                            Start Time  <ReqComponent />
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <TimePicker
                                value={formData.startTime}
                                onChange={(value) => handleChange("startTime", value)}
                                sx={{
                                    width: "100%",
                                    mt: 1,
                                    "& .MuiInputBase-root": {
                                        height: "48px",
                                        fontSize: "14px",
                                    },
                                }}
                                timeSteps={{ minutes: 30 }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    {/* ---------- TIME: TO ---------- */}
                    <Grid item xs={12} sm={6} md={3}>
                        <label style={{ fontSize: "14px" }}>
                            End Time <ReqComponent />
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <TimePicker
                                value={formData.endTime}
                                onChange={(value) => handleChange("endTime", value)}
                                sx={{
                                    width: "100%",
                                    mt: 1,
                                    "& .MuiInputBase-root": {
                                        height: "48px",
                                        fontSize: "14px",
                                    },
                                }}
                                timeSteps={{ minutes: 30 }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl sx={{ flexDirection: "row", alignItems: "center", gap: 2 }}>
                            <RadioGroup
                                row
                                value={formData.paidStatus}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    handleChange("paidStatus", value);

                                    if (value === "unpaid") {
                                        handleChange("paymentType", null);   // <-- reset dropdown
                                    }
                                }}
                            >
                                <FormControlLabel value="paid" control={<Radio />} label="Paid" />
                                <FormControlLabel value="unpaid" control={<Radio />} label="Unpaid" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    {formData.paidStatus === "paid" && (

                        <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }} style={{ marginLeft: "8px" }}>
                            <Grid className='pt-4' item xs={6} sm={6} md={6}>
                                <label style={{ fontSize: "14px", padding: '5px' }}>
                                    Payment Type <ReqComponent />
                                </label>
                                <TextField
                                    className='w-100'
                                    color='secondary'
                                    variant="outlined"
                                    select
                                    value={formData.paymentType}
                                    onChange={e => handleChange("paymentType", e.target.value)}
                                    SelectProps={{
                                        displayEmpty: true,
                                        renderValue: (value) => {
                                            return value
                                                ? value.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
                                                : "Select Payment Type";
                                        }
                                    }}
                                    InputProps={{
                                        sx: {
                                            height: '48px',
                                            fontSize: '14px'
                                        }
                                    }}
                                >
                                    <MenuItem disabled value="">
                                        <em style={{ color: "#9e9e9e" }}>Select Payment Type</em> {/* Placeholder visible in dropdown */}
                                    </MenuItem>
                                    <MenuItem value="department_paid">Department Paid</MenuItem>
                                    <MenuItem value="from_training">From Training</MenuItem>
                                </TextField>

                            </Grid>
                        </Grid>

                    )}


                    {/* ---------- SUBMIT BUTTON ---------- */}
                    <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }} className='pt-5 px-2' style={{ marginLeft: "8px" }}>
                        <ButtonTheme disabled={saving} type='submit' variant="filled" color='primary' className='px-5 mx-2'>
                            {saving && 'Loading...'}
                            {!saving && 'Save'}
                        </ButtonTheme>
                        {/* <ButtonTheme disabled={saving} onClick={() => setIsAdding(false)} variant="filled" className='px-5'>
                            Cancel
                        </ButtonTheme> */}
                    </Grid>

                </Grid>
            </form>
        </Paper>
        <Paper className="p-3" style={{ marginTop: "1rem" }}>
            <Typography variant="h6" className="mb-3">
                Off-Duty Listing
            </Typography>

            {loading && (
                <Box className="w-100 d-flex justify-content-center align-items-center mt-2"
                    style={{ height: '510px' }}>
                    <CircularProgress />
                </Box>
            )}
            {!loading && (
                <Box
                    sx={{
                        maxWidth: "93vw",
                        overflowX: "auto",
                        background: "#FFF",
                        marginTop: "1rem",
                    }}
                >


                    {odtRows.length > 0 ? (
                        <div className="hide-header-checkbox-page">
                            <MyTable
                                rows={odtRows}
                                columns={odtColumns}
                                // useTopFilter={false}
                                hideFooter={false}
                                checkboxSelection={false}
                                useCustomId={true}
                                minHeightRow="auto"
                            />
                        </div>
                    ) : (
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Off-Duty Training Requests Found
                            </span>
                        </div>
                    )}
                </Box>
            )}
        </Paper>
    </>


    );
};

export default OffDutyTraining;

